import userConsts from '#api/services/user/userConsts';
import {getValidUpRefCookie, setUpRefCookie} from '../helpers/upRefCookieHelpers';

const {COOKIE_KEYS} = userConsts;

class UserCookiesService {
	constructor() {
		/**
		 * @type {!Object}
		 * @private
		 */
		this.userData = getValidUpRefCookie();
	}

	/**
	 * @returns {string}
	 */
	getId() {
		return this.get(COOKIE_KEYS.USER_ID);
	}
	
	/**
	 * @returns {Array}
	 */
	getFavouriteArrangementIds() {
		return this.getArrayCookieData(COOKIE_KEYS.FAVOURITE_ARRANGEMENT_IDS);
	}
	
	/**
	 * @param {number} id
	 */
	storeFavouriteArrangementId(id) {
		this.storeValueInArray(COOKIE_KEYS.FAVOURITE_ARRANGEMENT_IDS, id);
	}
	
	/**
	 * @param {number} id
	 */
	removeFavouriteArrangementId(id) {
		this.storeArrayWithoutValue(COOKIE_KEYS.FAVOURITE_ARRANGEMENT_IDS, id);
	}
	
	/**
	 * @returns {boolean}
	 */
	hasRecentlyViewedItem() {
		return !!this.getRecentlyViewedEvents().length || !!this.getRecentlyViewedArrangements().length;
	}
	
	/**
	 * @returns {Array}
	 */
	getRecentlyViewedEvents() {
		return this.getArrayCookieData(COOKIE_KEYS.RECENTLY_VIEWED_EVENTS);
	}
	
	/**
	 * @param {!Array<!Object>} events
	 */
	storeRecentlyViewedEvents(events) {
		this.storeInUserData(COOKIE_KEYS.RECENTLY_VIEWED_EVENTS, events);
	}
	
	/**
	 * @param {number} id
	 */
	removeViewedEvent(id) {
		this.storeArrayWithoutId(COOKIE_KEYS.RECENTLY_VIEWED_EVENTS, id);
	}
	
	/**
	 * @returns {Array}
	 */
	getRecentlyViewedArrangements() {
		return this.getArrayCookieData(COOKIE_KEYS.RECENTLY_VIEWED_ARRANGEMENTS);
	}
	
	/**
	 * @param {!Array<!Object>} arranges
	 */
	storeRecentlyViewedArrangements(arranges) {
		this.storeInUserData(COOKIE_KEYS.RECENTLY_VIEWED_ARRANGEMENTS, arranges);
	}
	
	/**
	 * @param {number} id
	 */
	removeViewedArrangement(id) {
		this.storeArrayWithoutId(COOKIE_KEYS.RECENTLY_VIEWED_ARRANGEMENTS, id);
	}
	
	/**
	 * @returns {!Array<string>}
	 */
	getLastPackageSearches() {
		return this.getArrayCookieData(COOKIE_KEYS.PACKAGE_SEARCHES);
	}
	
	/**
	 * @param {string} key
	 * @returns {unknown}
	 */
	get(key) {
		return this.userData[key];
	}

	/**
	 * @param {string} key
	 * @returns {!Array}
	 */
	getArrayCookieData(key) {
		const value = this.userData[key];

		return Array.isArray(value) ? value : [];
	}

	/**
	 * @param {string} 					key
	 * @param {string|number|!Object} 	value
	 */
	storeValueInArray(key, value) {
		let rawValues = this.userData[key];

		if (!Array.isArray(rawValues)) {
			rawValues = [];
		}

		rawValues.push(value);

		this.storeInUserData(key, rawValues);
	}

	storeArrayWithoutId(key, id) {
		let rawValues = this.userData[key];

		if (Array.isArray(rawValues)) {
			const removeFromIndex = rawValues.findIndex((currentValue) => currentValue.id === id);
			
			if (removeFromIndex >= 0) {
				rawValues.splice(removeFromIndex, 1);
			}
		} else {
			rawValues = [];
		}

		this.storeInUserData(key, rawValues);
	}

	/**
	 * @param {string} 			   key
	 * @param {string|number|null} value
	 */
	storeArrayWithoutValue(key, value) {
		let rawValues = this.userData[key];

		if (Array.isArray(rawValues)) {
			const removeFromIndex = rawValues.indexOf(value);
			
			if (removeFromIndex >= 0) {
				rawValues.splice(removeFromIndex, 1);
			}
		} else {
			rawValues = [];
		}

		this.storeInUserData(key, rawValues);
	}

	/**
	 * @param {string} 	key
	 * @param {unknown} value
	 */
	storeInUserData(key, value) {
		this._updateCookieData(key, value);
		setUpRefCookie(this.userData);
	}

	/**
	 * @param {string} 	key
	 * @param {unknown} value
	 * @private
	 */
	_updateCookieData(key, value) {
		const removeKey = !value || (Array.isArray(value) && !value.length);

		if (removeKey) {
			delete this.userData[key];
		} else {
			this.userData[key] = value;
		}
	}

}

export default new UserCookiesService();